/* eslint-disable react/prop-types  */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';

const InputSelect = function ({
  id, name, options, target, required, hidden, defaultValue, onChange,
}) {
  return (
    <div
      className="inputSelect embeddedServiceSidebarFormField customField"
      style={{ display: hidden ? 'none' : 'block' }}
      data-target={target}
    >
      <div className="uiInput uiInputSelect uiInput--default uiInput--select">
        <label htmlFor={id} className="uiLabel-left form-element__label uiLabel">
          <span>{name}</span>
          {required ? <span title="Required" className="required">*</span> : undefined}
        </label>
        <select
          size="1"
          id={id}
          name={name}
          className={`${id} slds-style-select select`}
          disabled={hidden}
          required={required}
          onChange={onChange}
        >
          {!defaultValue
            ? (
              <option
                label="--None--"
                value=""
                className="optionClass"
              >--None--
              </option>
            )
            : undefined}
          {options.map(({ label, value }) => (
            <option
              label={label}
              value={value}
              className="optionClass"
              selected={value === defaultValue}
            >
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default InputSelect;
